import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { projectsActions } from '../../actions';
import {
  FetchVisualizePromptActionPayload,
  FillVisualizePromptActionPayload,
} from '../../typedefs';

export function* fetchVisualizePrompt({
  payload,
}: PayloadAction<FetchVisualizePromptActionPayload>) {
  try {
    yield effects.put(projectsActions.startPromptFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: `messages/${payload.messageId}/visualize_prompt` },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillVisualizePromptActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(
      projectsActions.fillVisualizePrompt({
        ...data,
        messageId: payload.messageId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(projectsActions.stopPromptFetching());
  }
}
